import React from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'react-toolbox/lib/checkbox';
import {
  selectAllModuleItems,
  showRemoveModuleItemsConfirmationDialog,
} from 'manage-modules/redux/manageModulesActions';
import RemoveButton from 'components/RemoveButton';
import PanelLoadingIndicator from 'components/PanelLoadingIndicator';
import ModuleItemsList from 'manage-modules/components/card/ModuleItemsList';
import theme from 'manage-modules/components/card/ModuleItemsTabTheme.css';

const ModuleItemsTab = ({
  allItemsSelected,
  onClickRemove,
  onSelectAllChange,
  itemsLoaded,
  itemsSynced,
  removeButtonVisible,
  removeItemsDisabled,
  selectAllDisabled,
}) =>
  itemsLoaded
    ? <div className={theme.container}>
        <div className={theme.listHeaderContainer}>
          <Checkbox
            theme={theme}
            checked={allItemsSelected}
            onChange={onSelectAllChange}
            disabled={selectAllDisabled}
          />
          {removeButtonVisible &&
            <RemoveButton
              label="Remove"
              onClick={onClickRemove}
              className={theme.removeButton}
            />}
        </div>
        <div className={theme.listContainer}>
          <ModuleItemsList />
        </div>
      </div>
    : <PanelLoadingIndicator />;

const mapStateToProps = state => {
  const moduleCardState = state.manageModules.moduleCard;

  return {
    allItemsSelected:
      moduleCardState.items.length > 0 &&
      moduleCardState.selectedItemIds.length === moduleCardState.items.length,
    itemsLoaded: moduleCardState.itemsLoaded,
    selectAllDisabled: moduleCardState.items.length < 1,
    removeButtonVisible: moduleCardState.selectedItemIds.length > 0,
  };
};

const mapDispatchToProps = dispatch => ({
  onClickRemove: () => {
    dispatch(showRemoveModuleItemsConfirmationDialog());
  },
  onSelectAllChange: value => {
    dispatch(selectAllModuleItems(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleItemsTab);
